// Şantiye konum ağacı yardımcıları. Sunucu düz liste döner, ağaç `parent_id`
// ile kurulur (bkz. backend/routes/insaat.py — ŞANTİYE KONUMLARI).
import { trNorm } from '@/lib/arama';

export const KONUM_ADI = { etap: 'Etap', blok: 'Blok / Bölge', kat: 'Kat', bolum: 'Bağımsız Bölüm', mahal: 'Mahal' };

// Bir konumun bağlı olduğu blok (etap ya da şantiye geneli ise null).
export const blokunuBul = (id, harita) => {
  let k = harita[id];
  for (let i = 0; k && i < 8; i++) {
    if (k.tur === 'blok') return k;
    k = harita[k.parent_id];
  }
  return null;
};
export const SANTIYE_GENELI = 'Şantiye geneli';

// Doğal sıra: "D2" < "D10" (düz sıralama "D10"u "D2"nin önüne koyar).
export const dogalSira = (a, b) =>
  (a.ad || '').localeCompare(b.ad || '', 'tr', { numeric: true, sensitivity: 'base' });

// Kat sırası: alfabetik sıra "1. Kat"ı "Zemin Kat"ın önüne koyuyordu; sahada
// beklenen bodrum → zemin → 1, 2… → çatı. Tanınmayan ad sona, doğal sırayla.
const katSirasi = (ad) => {
  const n = trNorm(ad);
  const sayi = parseInt((n.match(/-?\d+/) || [])[0], 10);
  if (n.includes('bodrum')) return -(Number.isNaN(sayi) ? 1 : Math.abs(sayi));
  if (/^-\s*\d/.test(n)) return sayi;
  if (n.includes('zemin')) return 0;
  if (n.includes('cati') || n.includes('teras')) return 9999;
  if (!Number.isNaN(sayi)) return sayi;
  return 5000;
};
const katSira = (a, b) => (katSirasi(a.ad) - katSirasi(b.ad)) || dogalSira(a, b);

export const haritala = (konumlar) => Object.fromEntries((konumlar || []).map((k) => [k.id, k]));

export const cocuklar = (konumlar, parentId, tur) =>
  (konumlar || [])
    .filter((k) => (k.parent_id || null) === (parentId || null) && (!tur || k.tur === tur))
    .sort(tur === 'kat' ? katSira : dogalSira);

export const konumYolu = (id, harita) => {
  const parcalar = [];
  let k = harita[id];
  for (let i = 0; k && i < 8; i++) {
    parcalar.unshift(k.ad);
    k = harita[k.parent_id];
  }
  return parcalar.join(' / ');
};
